export default {
  SET: "NOTIFICATION_INFO.SET",
  CLOSE_LATEST: "NOTIFICATION_INFO.CLOSE_LATEST",
  CLOSE_ALL: "NOTIFICATION_INFO.CLOSE_ALL",
  SHIFT: "NOTIFICATION_INFO.SHIFT",
  CLEAR: "NOTIFICATION_INFO.CLEAR",
  CLOSE_BY_ID: "NOTIFICATION_INFO.CLOSE_BY_ID",
};
